import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constant } from 'app/core/common/constant';
import { CommonService } from 'app/core/services/common.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tax-type-form',
  templateUrl: './tax-type-form.component.html',
  styleUrl: './tax-type-form.component.scss'
})
export class TaxTypeFormComponent implements OnInit{

  //#region Variables
  @Input() taxTypeList: any[] = [];
  @Input() editTax: any;
  @Input() operationNumber: number;

  @Output() refreshTaxType = new EventEmitter<boolean>();
  @Output() closeForm = new EventEmitter<boolean>();
  form: FormGroup;
  disableSave: boolean = false;

  constructor(
    private commonService: CommonService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
  ) {}

  ngOnInit(){
    this.form = this.fb.group({
      id: [0],
      name: ['', Validators.required],
      rate: [null, [Validators.required, Validators.min(0)]],
    });
    if(this.operationNumber == 1){
      this.onEdit(this.editTax?.id);
    }
  }

  onEdit(id) {
    this.form.patchValue({
      id:id,
      name:this.editTax?.name,
      rate:this.editTax?.rate
    })
  }

  onSave(){
    this.disableSave = true;
    this.form.markAllAsTouched();
    if(this.form.valid){
      let name = this.form.value.name;
      let isTypeExists = this.taxTypeList.some((item)=>item.name.toLocaleLowerCase()===name.toLocaleLowerCase());
      if (this.operationNumber == 1){
        isTypeExists = false;
      }
      if (isTypeExists){
        this.toastrService.warning(`Tax with name ${name} already exist`,Constant.ToasterHeader.Warning);
        this.disableSave = false;
        return
      }
      this.commonService.saveTaxType(this.form.value).subscribe(resp=>{
        this.form.reset(
          {
            id:0,
            name:resp.name
          }
        );
        this.form.reset();
        this.disableSave = false;
        this.exitForm();
        this.toastrService.success(Constant.ToasterBody.Success,Constant.ToasterHeader.Success);
      })
    }else{
      this.disableSave = false;
    }
  }

  exitForm(){
    this.refreshTaxType.emit(true);
    this.closeForm.emit(true);
  }
}
